var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5c0 1.65-1.45 3-3.25 3s-3.25-1.35-3.25-3H17z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.5H9c-.55 0-1-.45-1-1V7.65C8 4.5 10.45 2 13.5 2S19 4.5 19 7.65v2.85c0 .55-.45 1-1 1z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 22C10.45 22 9 20.65 9 19h6.5c0 1.65-1.45 3-3.25 3zM21 15.3c-.15 1.85-1.8 3.2-3.65 3.2H6.65c-1.85 0-3.5-1.4-3.65-3.2-.15-1.9 1.2-3.45 2.95-3.75V8.5c0-2.7 1.8-5 4.25-5.75.1-1 .95-1.75 2-1.75 1.1 0 1.95.85 2 1.95 2.2.95 3.75 3.2 3.75 5.75v2.8c1.85.3 3.2 1.9 3.05 3.8zm-1-.1c.1-1.3-.85-2.5-2.15-2.65-.5-.05-.85-.5-.85-1v-2.8c0-2.1-1.25-3.95-3-4.75-.6-.25-1.35-.5-2-.5-.55 0-1.1.1-1.6.25C8.4 4.4 7 6.3 7 8.5v3.05c0 .5-.35.95-.85 1C4.85 12.7 3.9 13.9 4 15.2c.1 1.3 1.25 2.3 2.65 2.3h10.7c1.4 0 2.55-1 2.65-2.3z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.cf8f6caf98427879c3fd32ffa6d65f6f.svg";
export { ForwardRef as ReactComponent };